import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
var re = /(?:\r\n|\r|\n)/g;
var useStyles = makeStyles({
  root: {},
  paragraph: {
    display: 'block',
    marginTop: '1em',
    marginBottom: '1em',
    marginLeft: 0,
    marginRight: 0
  }
}, {
  name: 'SxMultilineText'
});
/**
 * Pokud je `children` typu `string` upravy jej pro zobrazeni ve vice radcich. Jine typy `children` renderuje
 * beze zmeny.
 *
 * @component
 */

function MultilineText(_ref) {
  var children = _ref.children,
      Component = _ref.component;
  var classes = useStyles();
  return typeof children === 'string' && re.test(children) ? React.createElement(React.Fragment, null, children.split(re).map(function (item, key) {
    return React.createElement(Component, {
      key: key.toString(),
      className: classes.paragraph
    }, item);
  })) : React.createElement(React.Fragment, null, children);
}

MultilineText.propTypes = {
  children: PropTypes.node,
  component: PropTypes.elementType
};
MultilineText.defaultProps = {
  children: null,
  component: 'span'
};
export default MultilineText;